import React, { Fragment } from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import media from 'utils/media-queries'

import { color, fontSize } from 'styles/theme'

import TwoColumns from 'components/twoColumns'
import SectionHeading from 'components/sectionHeading'

const Big = styled.span`
  font-size: ${fontSize.f6};
  color: ${color.grey900};
  font-weight: 700;
  letter-spacing: -0.4px;
  line-height: 1.35;
  ${media.lg`
    font-size: ${fontSize.f5};
    letter-spacing: -0.3px;
  `}
  ${media.sm`
    font-size: ${fontSize.f5};
  `}
`

const About = () => {
  return (
    <TwoColumns
      leftColumn={<SectionHeading>About</SectionHeading>}
      rightColumn={
        <Fragment>
          <Big>
            Hi. I'm Aniket, Software Engineer and Robotics &nbsp;Enthusiast living in Pune.
          </Big>
          <p>
            I graduated from the Indian Institute of Technology (IIT) Kharagpur, India
            with a bachelors degree in Manufacturing&nbsp;Science & Engineering.
          </p>
          <p>
            Currently I'm developing new products for CAD users at
            Siemens&nbsp; Digital&nbsp; Industries. 
          </p>
          <p style={{ marginBottom: 0 }}>
            Apart from work I like trekking, playing Piano and hitting gym.
          </p>
        </Fragment>
      }
    />
  )
}

export default About
